<ngx-skeleton-loader
  *ngIf="itemsLoading$ | async; else itemOptions"
  count="1"
  appearance="line"
></ngx-skeleton-loader>
<ng-template #itemOptions>
  <button
    [testId]="testIds.FINALIZE_BUTTON"
    [disabled]="(canFinalizeDocket$ | async) === false"
    mat-flat-button
    color="primary"
    (click)="finalize()"
  >
    Finalize
  </button>
</ng-template>
<ngx-skeleton-loader
  *ngIf="docketLoading$ | async; else docketSettings"
  count="3"
  appearance="line"
></ngx-skeleton-loader>
<ng-template #docketSettings>
  <ng-container *ngIf="docket$ | async as docket">
    <app-key-value-pair
      [testId]="testIds.PURCHASE_ORDER"
      data-cy="purchase-order"
      name="Purchase order"
      [value]="docket.purchase_order"
    ></app-key-value-pair>
    <app-key-value-pair
      [testId]="testIds.PAYMENT_STATUS"
      *ngIf="docket.status !== 'draft' && docket.status !== 'void'"
      name="Payment status"
      data-cy="payment-status"
      [value]="docket.payment_status | titlecase"
    ></app-key-value-pair>
    <div class="flex flex-row space-x-4 justify-center lg:justify-end">
      <a
        [testId]="testIds.VIEW_ON_XERO"
        *ngIf="docket.xero_id"
        href="https://invoicing.xero.com/edit/{{ docket?.xero_id }}"
        mat-button
        >View on Xero</a
      >
      <button
        [testId]="testIds.OPEN_SETTINGS_BUTTON"
        mat-flat-button
        (click)="openSettingsDialog()"
      >
        Edit
      </button>
    </div>
  </ng-container>
</ng-template>
